import api from "../../../utilidades/interceptor";
const apiUrl = process.env.REACT_APP_API_KEY


export const getAsistencias = async (params) => {
    try {
        const response =  await api.post(`${apiUrl}/talentoHumano/getAsistencia`,params);
        return response.data;

    } catch(err) {
        console.log(err);
        throw new Error(err);
    }
}
